import failed from './failed.svg'
const IconFailed = () => {
  return (
        <>
            <img src={failed} width="16px"/>
        </>
  )
}
export default IconFailed
